const doc = [({"da":({"js":({"admin":({"highscore_generations":({"show":({"generation_at_date_in_highscore":"Generation d. %{generated_at} i %{highscore_name}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;